import Box from "@mui/material/Box";
import { DataGridProps, GridColDef } from "@mui/x-data-grid";
import React from "react";
import {
  StyledDataGrid,
  StyledEmptyWrapper,
  StyledPaper,
  StyledTypography,
} from "./styled";

export type Columns = GridColDef[];

interface Props<T> extends Omit<DataGridProps, "rows" | "columns"> {
  columns?: any[];
  data: T[];
  loading?: boolean;
  title?: string;
  heightTable?: string | number;
  emptyStateMessage?: string;
  actions?: React.ReactNode;
  minHeight?: string;
}

const TableWithPagination = <T extends object>({
  data,
  columns,
  title,
  heightTable = "70vh",
  loading,
  emptyStateMessage = "No results",
  actions,
  minHeight,
  ...rest
}: Props<T>) => {
  const getAllColumns = (data: T[]) => {
    return Object.keys(data[0]).map((field) => ({ field }));
  };

  if (!loading && !data.length) {
    return (
      <StyledPaper>
        <StyledEmptyWrapper>
          <StyledTypography>{emptyStateMessage}</StyledTypography>
        </StyledEmptyWrapper>
      </StyledPaper>
    );
  }

  return (
    <Box sx={{ width: "100%", height: heightTable, minHeight }}>
      <StyledDataGrid
        {...rest}
        columns={columns || getAllColumns(data)}
        rows={data}
        disableColumnMenu
        rowHeight={48}
        loading={loading}
        localeText={{ noRowsLabel: emptyStateMessage }}
        disableRowSelectionOnClick
      />
    </Box>
  );
};

export default TableWithPagination;
